export default __webpack_public_path__ + "static/media/download-icon.89c87d8e.svg";